import { SortDirection } from '../../list-conductor/sort';
import { JobObjectFailureStage } from '../interfaces/job';

export const JOB_OBJECT_STAGE_FAILURE_STAGE_MAP = {
  ingest: JobObjectFailureStage.INGESTOR,
  load: JobObjectFailureStage.LOADER
};

export const DEFAULT_SORT = { created_at: SortDirection.DESC };

export const LATENCY_DEFINITION =
  'Latency is the difference between when data was created/updated at Source and loaded to your Destination';
